export default "__VITE_ASSET__Djn5tUgB__"